module.exports = __webpack_public_path__ + "img/lr1-mc-rron1.d432fd00.gif";